var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1147,
    height: 1189,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1625,
    y: 642,
    width: 1147,
    height: 1189
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1625 -642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2771.83 1100.04C2771.83 1428.1 2471.07 1830.93 2120.7 1830.93 1786.68 1830.93 1650.01 1626.66 1638.01 1323.3 1636.88 1294.59 1634.31 1265.96 1630.76 1237.44 1591.94 926.266 1784.96 642.933 2120.7 642.933 2471.07 642.933 2771.83 771.989 2771.83 1100.04",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350.28 1462.93 2350.28 1095.43C2350.28 1089.64 2345.57 1084.93 2339.77 1084.93L2266.2 1084.93C2260.39 1084.93 2255.69 1089.64 2255.69 1095.43L2255.69 1462.93 2245.18 1462.93 2245.18 1189.93C2245.18 1184.13 2240.47 1179.43 2234.67 1179.43L2161.1 1179.43C2155.29 1179.43 2150.58 1184.13 2150.58 1189.93L2150.58 1462.93 2140.07 1462.93 2140.07 1252.93C2140.07 1247.14 2135.37 1242.43 2129.57 1242.43L2055.99 1242.43C2050.19 1242.43 2045.48 1247.14 2045.48 1252.93L2045.48 1462.93 2034.97 1462.93 2034.97 1326.43C2034.97 1320.63 2030.27 1315.93 2024.46 1315.93L1950.89 1315.93C1945.09 1315.93 1940.38 1320.63 1940.38 1326.43L1940.38 1462.93 1887.83 1462.93 1887.83 1483.93 2402.83 1483.93 2402.83 1462.93 2350.28 1462.93ZM2013.95 1462.93 1961.4 1462.93 1961.4 1384.18 2013.95 1384.18 2013.95 1462.93ZM2013.95 1363.18 1961.4 1363.18 1961.4 1336.93 2013.95 1336.93 2013.95 1363.18ZM2119.06 1462.93 2066.5 1462.93 2066.5 1310.68 2119.06 1310.68 2119.06 1462.93ZM2119.06 1289.68 2066.5 1289.68 2066.5 1263.43 2119.06 1263.43 2119.06 1289.68ZM2224.16 1462.93 2171.6 1462.93 2171.6 1247.68 2224.16 1247.68 2224.16 1462.93ZM2224.16 1226.68 2171.6 1226.68 2171.6 1200.43 2224.16 1200.43 2224.16 1226.68ZM2329.26 1462.93 2276.71 1462.93 2276.71 1153.18 2329.26 1153.18 2329.26 1462.93ZM2329.26 1132.18 2276.71 1132.18 2276.71 1105.93 2329.26 1105.93 2329.26 1132.18Z",
    fill: "#1930AB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1947.72 1286.93 2187.77 1046.89 2187.77 1084.65 2208.83 1084.65 2208.83 1021.46C2208.83 1015.65 2204.12 1010.93 2198.3 1010.93L2129.84 1010.93 2129.84 1031.99 2172.87 1031.99 1932.83 1272.04 1947.72 1286.93Z",
    fill: "#1930AB",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.f85210c4049e7d2317d5d729a8b8e233.svg";
export { ForwardRef as ReactComponent };